<template>
  <div class="dynamic_add">
    <div class="add_title">
      <div>{{addDynamic.id ? '编辑动态页' : '新增动态页'}}</div>
      <el-button class="add_back" @click="$router.go(-1)">返回</el-button>
    </div>
    <el-form ref="addDynamicRef" :model="addDynamic" label-width="100px">
      <el-form-item label="页面标题:" prop="title" :rules="[{ required: true, message: '请输入页面标题', trigger: 'blur' }]">
        <el-input size="small" style="width: 200px" v-model="addDynamic.title"></el-input>
      </el-form-item>
      <el-form-item label="页面描述:" prop="description" :rules="[{ required: true, message: '请输入页面描述', trigger: 'blur' }]">
        <el-input size="small" style="width: 200px" v-model="addDynamic.description"></el-input>
      </el-form-item>
      <el-form-item label="背景色:">
        <el-color-picker v-model="addDynamic.backgroundColor"></el-color-picker>
      </el-form-item>
      <el-form-item label="选择组件:">
        <el-row class="components__icon">
          <el-col :span="2">
            <i id="img" draggable="true" v-tip.dark.top="'图片'" @dragstart="drag" class="fa el-icon-picture">
            </i></el-col>
          <el-col :span="2">
            <i id="coupon" draggable="true" v-tip.dark.top="'优惠券'" @dragstart="drag" class="fa el-icon-s-ticket"></i>
          </el-col>
          <el-col :span="2">
            <i class="fa el-icon-document" aria-hidden="true" id="text" draggable="true" v-tip.dark.top="'文本'"
              @dragstart="drag"></i>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <div class="phone">
      <img src="@/assets/images/phone_bg.png" class="phone__bg" alt="">
      <div class="phone__content" @drop="drop" @dragover="allowDrop">
        <div v-for="(item, index) in list" :key="index">
          <div class="components components__img" @click="setComponent(item, index)"
            :style="item.style + ';height:' + item.height + 'px'" v-if="item.type === 'img'"
            @dragstart="dragStartComponent(arguments[0], index)" id="images" draggable="true">
            <el-carousel v-if="item.imgType === 0" :interval="5000" arrow="never" indicator-position="none"
              :height="item.height ? item.height + 'px' : '100px'">
              <el-carousel-item v-if="item.imgList.length > 0" v-for="(items, indexs) in item.imgList" :key="indexs">
                <img draggable="true" @click="setComponent(item, index)" :width="item.width" :height="item.height"
                  :src="items.url">
              </el-carousel-item>
              <el-carousel-item v-else>
                <img draggable="true" @click="setComponent(item, index)" :width="item.width" :height="item.height"
                  src="@/assets/images/defaultImg.png">
              </el-carousel-item>
            </el-carousel>
            <img v-else-if="item.imgType === 1 || item.imgType === -1" :width="item.width" :height="item.height"
              :src="item.url || item.imgList[0].url" alt="" style="max-width:268px">
            <i @click.stop="componentDelete(index)" class="el-icon-circle-close components__del"> </i>
          </div>

          <div class="components components__coupon" :style="item.style" v-else-if="item.type === 'coupon'"
            @click="setComponent(item, index)" draggable="true" id="coupons"
            @dragstart="dragStartComponent(arguments[0], index)">
            <div v-if="item.data" class="coupon_warp">
            <!-- <div class="coupon_warp"> -->
              <div class="coupon_warp_content">
                <div class="coupon_warp_content_left">
                  <div class="coupon_price_warp">
                    <div class="size16">{{item.data.couponMoney}}</div>
                    <div>元</div>
                  </div>
                  <div class="size12 color667 mt4" v-if="item.data.couponMoneyFloor == 0">无门槛</div>
                  <div class="size12 color667 mt4" v-else>满{{ item.data.couponMoneyFloor }}可用</div>
                </div>
                <div class="coupon_warp_content_right">
                  <div class="font600">{{item.data.couponName}}</div>
                  <div class="color667 mt4">领券后{{item.data.couponUseDay}}天内使用</div>
                </div>
              </div>
              <div class="coupon_warp_bottom" v-if="item.data.couponDescribe">
                <div class="color667">{{ item.data.couponDescribe }}</div>
              </div>
            </div>
            <div v-else style="line-height: 100px;text-align: center">暂未选择优惠券</div>
            <i @click.stop="componentDelete(index)" class="el-icon-circle-close components__del"> </i>
          </div>
          <div class="components components__text" :style="item.style" v-else-if="item.type === 'text'"
            @click="setComponent(item, index)" draggable="true" id="texts"
            @dragstart="dragStartComponent(arguments[0], index)">
            <div v-if="item.data">
              <div class="ql-container ql-snow" style="border: 0px solid #fff;">
                <div class="ql-editor" v-html="item.data">
                </div>
              </div>
            </div>
            <div v-else style="line-height: 100px;text-align: center">暂无文本内容</div>
            <i @click.stop="componentDelete(index)" class="el-icon-circle-close components__del"> </i>
          </div>
          <div class="components components__button" :style="`min-height:${item.btnStyle.height}px;${item.style}`"
            v-else-if="item.type === 'button'" @click="setComponent(item, index)" draggable="true" id="buttons"
            @dragstart="dragStartComponent(arguments[0], index)">
            <div v-if="item.data">
              <el-button
                :style="`height:${item.btnStyle.height}px;width:${item.btnStyle.width}%;background-color:${item.btnStyle.backgroundColor};color:${item.btnStyle.color};font-size:${item.btnStyle.fontSize}px;line-height:${item.btnStyle.height}px;padding:0;border-radius:${item.btnStyle.borderRadius}px`">
                {{ item.data }}
              </el-button>
            </div>
            <div v-else style="line-height: 100px;text-align: center;">暂未设置按钮</div>
            <i @click.stop="componentDelete(index)" class="el-icon-circle-close components__del"> </i>
          </div>
        </div>
      </div>
    </div>
    <div class="set" v-if="setData.show">
      <el-card class="box-card">
        <div slot="   ">
          <span>{{ setData.title }}</span>
          <span class="box-card__prompt" v-if="setData.type === 'button'">按钮与相应的业务绑定后不可再更改类型</span>
        </div>
        <img-edit ref="img-edit-ref" v-if="setData.type === 'img'" :dynamicPageApply='addDynamic.dynamicPageApply'
          :edit-data="setData.data"></img-edit>
        <coupon-edit ref="coupon-edit-ref" v-else-if="setData.type === 'coupon'" :edit-data="setData.data"></coupon-edit>
        <text-edit v-else-if="setData.type === 'text'" :edit-data="setData.data"></text-edit>
        <el-row style="margin-top: 30px">
          <el-col :offset="16" :span="3">
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
          <el-col :offset="2" :span="3">
            <el-button type="primary" size="small" :loading="saveLoading" @click="dynamicAdd">保存</el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <!-- 获取兼容性样式前缀使用 -->
    <div ref='_style'></div>
  </div>
</template>

<script type="text/babel">
import ImgEdit from './dynamic-components/img-edit'
import CouponEdit from './dynamic-components/coupon-edit'
import TextEdit from './dynamic-components/text-edit'
import Move from './dynamic-components/move'
import { addDynamic, getDynamic,editDynamic,getCouponList } from '@/api/mobile'
import { isNull } from '@/utils/validateBase'

// import { PlatformService } from 'src/service'

let dragStartImgScollY = 0
let dragStartImgIndex = 0
let refName = 0
const componentDragList = ['data:image', 'https', 'coupons', 'medicines', 'images', 'texts', 'buttons']
const componentTypeList = ['img', 'coupon', 'text']
const componentData = {
  img: {
    type: 'img',
    width: '268',
    height: '100',
    ref: null,
    style: '',
    imgType: 1,
    imgList: [],
    url: '',
    fullType: '3',
    index: 0,
  },
  coupon: {
    type: 'coupon',
    data: null,
    backgroundImg: require('@/assets/images/get_coupon_bg@2x.png'),
    couponTypeId: null,
    ref: null,
    index: null,
    rowCount: 1
  },
  text: {
    type: 'text',
    data: null,
    ref: null,
    index: null,
    style: ''
  },
}
export default {
  name: 'dynamic-add',
  components: {
    ImgEdit,
    CouponEdit,
    TextEdit,
    Move
  },
  data() {
    return {
      addDynamic: {
        title: '',
        description: '',
        color: '#ffffff',
        dynamicPageId: null
      },
      loading: false,
      list: [],
      setData: {
        show: true,
        title: '编辑',
        data: {},
        type: ''
      },
      resultData: {},
      page: {
        pageIndex: 1,
        pageSize: 1000000,
        totalElements: 0,
        couponUsageType: 2
      },
      saveLoading: false,
      allCouponList: [],
      backgroundColor: 'linear-gradient(0deg, #cccccc 20%, #000000 70%)',
      backgroundimg: require('@/assets/images/backgroundimg.png'),
      compatible_style: null
    }
  },
  watch: {},
  mounted() {
    this.compatible_style = this.vendor()
    this.pageEdit()
    // this.getCouponList()
  },
  methods: {
    async getCouponList(){
      let params = { pageIndex:1,pageSize:50}
      let { code, data } = await getCouponList(params)
      if(code == 200 ){
        componentData.coupon.couponList = data.records
      }
    },
    /** 设置样式兼容性 */
    vendor() {
      let transformNames = {
        webkit: 'webkitTransform',
        Moz: 'MozTransform',
        O: 'OTransform',
        ms: 'msTransform',
        standard: 'transform'
      }
      for (let key in transformNames) {
        if (this.$refs._style.style[transformNames[key]] !== undefined) {
          return `-${key}-`
        }
      }
      return null
    },
    /*
     * 编辑活动页面(数据填充)
     * */
    pageEdit() {
      const vm = this
      const pageId = vm.$route.query.pageId
      if (!pageId) {
        return
      }
      getDynamic({ pageId }).then((res) => {
        if (res.code == 200) {
          vm.addDynamic = {
            title: res.data.title,
            description: res.data.description,
            backgroundColor: res.data.backgroundColor,
            id: pageId,
          }
          let backgroundColor = [] //优惠券背景色
          const arr = ['-webkit-', '-Moz-', '-ms-', '-O-', '-standard-']
          res.data.pageItemList.forEach((ele, index) => {
            const component = vm.$lodash.cloneDeep(vm.addComponent(componentTypeList[ele.type - 1]))
            component.id = ele.id
            if (component.type === 'img') {
              component.height = ele.dynamicPageItemPictures[0].height
              component.width = ele.dynamicPageItemPictures[0].width
              component.imgList = []
              component.fullType = ele.fillStyle + ''
              ele.dynamicPageItemPictures.forEach((imgItem) => {
                imgItem.hotList && imgItem.hotList.forEach((v) => {
                  if (v.hrefType == 2) {
                    let obj = JSON.parse(v.href)
                    v.doctorId = obj.doctorId
                    v.doctorName = obj.doctorName
                  }
                })
                component.imgList.push({
                  url: imgItem.picUrl,
                  src: imgItem.shortPicUrl,
                  medicineNumber: imgItem.medNumber,
                  originHeight: imgItem.originHeight,
                  originWidth: imgItem.originWidth,
                  href: imgItem.href,
                  hotList: imgItem.hotList,
                  hrefType: imgItem.hrefType,
                  doctorId: imgItem.hrefType == 2 ? JSON.parse(imgItem.href).doctorId : '',
                  doctorName: imgItem.hrefType == 2 ? JSON.parse(imgItem.href).doctorName : '',
                })
              })
              component.imgType = ele.rowCount
            } else if (component.type === 'coupon') {
              component.data = ele.dynamicPageItemCoupon.couponTypeInfo
              component.couponTypeId = ele.dynamicPageItemCoupon.couponTypeId
              component.rowCount = ele.rowCount
              component.backgroundColor = ele.dynamicPageItemCoupon.backgroundColor
              console.log("🚀 ~ res.data.pageItemVOList.forEach ~ component:", component)
              /** 判断优惠券背景色  兼容性前缀 */
              if (ele.backGroundColor) {
                let _boo = true
                arr.forEach(x => {
                  /** 无内核前缀 */
                  if (!ele.backGroundColor.includes(x)) {
                    _boo = false
                  } else {
                    if (x != vm.compatible_style) {
                      ele.backGroundColor = ele.backGroundColor.substring(0, x.length)
                    } else {
                      _boo = false
                    }
                  }
                })
                if (_boo) {
                  ele.backGroundColor = vm.compatible_style + ele.backGroundColor
                }
                backgroundColor.push(ele.backGroundColor)
              }
            } else if (component.type === 'text') {
              component.data = ele.dynamicPageItemText.content
            }
            vm.list.push(component)
          })
        }
      })
    },
    /*
     * 组件开始拖拽，将放置到配置页面
     * */
    drag(e) {
      e.dataTransfer.setData('Text', e.target.id)
    },
    /*
     * 组件拖拽完成，并放置到配置页面
     * */
    allowDrop(e) {
      e.preventDefault()
    },
    /*
     * 配置页面做拽调整组件的顺序
     * */
    dragStartComponent(e, index) {
      dragStartImgScollY = e.clientY
      dragStartImgIndex = index
      e.dataTransfer.setData('Text', e.target.id)
    },
    /*
     * 判断组件已经放入模块内，并且允许拖放
     * */
    componentDrag(componentType) {
      return componentDragList.findIndex((ele) => componentType.indexOf(ele) === 0) >= 0
    },
    /*
     * 组件拖拽完成，调节组件顺序或者添加组件
     * */
    drop(e) {
      const vm = this
      e.preventDefault()
      const componentType = e.dataTransfer.getData('Text')
      if (componentTypeList.find(ele => ele === componentType) && componentType) {
        vm.list.push(vm.$lodash.cloneDeep(vm.addComponent(componentType)))
      } else if (vm.componentDrag(componentType)) {
        vm.dragComponent(e)
      }
    },
    /*
     * 添加组件
     * */
    addComponent(componentType) {
      const vm = this
      let component = vm.$lodash.cloneDeep(componentData[componentType])
      if (componentType === 'coupon') {
        component.data = null
        component.couponTypeId = null
        component.backgroundColor = '#fff'
      } else if (componentType === 'img') {
        component.imgList = [
          {
            url: require('@/assets/images/defaultImg.png'),
            src: '',
            hrefType: 1,
            href: '',
            doctorName: '',
            doctorId: '',
            medicineNumber: null,
            originWidth: null,
            originHeight: null
          }
        ]
      }
      component.ref = componentType + 'Ref' + refName
      component.index = vm.list.length
      refName++
      return component
    },
    /*
     * 拖拽组件调整位置
     * */
    dragComponent(e) {
      const vm = this
      const moveNum = Math.round((e.clientY - dragStartImgScollY) / 100)
      const listLength = vm.list.length
      if (listLength >= 2 && Math.abs(moveNum) >= 1) {
        const moveObj = vm.list[dragStartImgIndex]
        vm.list.splice(dragStartImgIndex, 1)
        let moveIndex = moveNum + dragStartImgIndex
        if (moveIndex > vm.list.length - 1) {
          moveIndex = vm.list.length
        } else if (moveIndex < 0) {
          moveIndex = 0
        }
        vm.list.splice(moveIndex, 0, moveObj)
        vm.list.map((ele, index) => {
          ele.index = index
          return ele
        })
      }
    },
    /*
     * 移除组件
     * */
    componentDelete(index) {
      const vm = this
      vm.list.splice(index, 1)
      if (vm.list.length === 0) {
        vm.reloadComponent()
      } else {
        vm.list.map((ele, index) => {
          ele.index = index
          return ele
        })
      }
    },
    reloadComponent() {
      const vm = this
      vm.setData.type = null
      vm.setData.title = '编辑'
      vm.setData.data = {}
    },
    /*
     * 设置组件
     * */
    setComponent(row, index) {
      const vm = this
      vm.setData.type = row.type
      vm.setData.show = true
      vm.setData.data = row
      let doctorInfo = null
      row.imgList && row.imgList.forEach(v1 => {
        if (v1.hrefType == 2) {
          doctorInfo = JSON.parse(v1.href)
        }
        v1.hotList && v1.hotList.forEach(v2 => {
          if (v2.hrefType == 2) {
            doctorInfo = JSON.parse(v2.href)
            v2.doctorId = doctorInfo.doctorId
            v2.doctorName = doctorInfo.doctorName
          }
        })
      })
      if (row.type === 'img') {
        vm.setData.title = '图片编辑'
        vm.$nextTick(() => {
          vm.$refs['img-edit-ref'].changeType()
          vm.$refs['img-edit-ref'].couponIdsFill()
          doctorInfo && vm.$refs['img-edit-ref'].doctorOptions.push(doctorInfo)
        })
      } else if (row.type === 'coupon') {
        vm.setData.title = '优惠券编辑'
        vm.$nextTick(() => {
          vm.$refs['coupon-edit-ref'].couponList = []
          row.data && vm.$refs['coupon-edit-ref'].couponList.push(row.data)
        })
      } else if (row.type === 'text') {
        vm.setData.title = '文本编辑'
      }

      vm.list.map((ele, indexs) => {
        if (indexs === index) {
          ele.style = 'border-color: red'
        } else {
          ele.style = ''
        }
        return ele
      })

    },
    /*
     * 重置
     * */
    reset() {
      const vm = this
      vm.$confirm('确定重置当前活动页面?', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        vm.list = []
        vm.reloadComponent()
      })
    },
    /*
     * 保存
     * */
    dynamicAdd() {
      const vm = this
      vm.$refs.addDynamicRef.validate((valid) => {
        if (!valid) {
          return false
        }
        const { verification, pageItemVOList } = vm.dealPageItemList()
        if (verification) {
          return
        }

        vm.saveLoading = true
        vm.$confirm('确定保存整个页面活动？', '保存活动页面').then(() => {
          const pageData = {
            title: vm.addDynamic.title,
            description: vm.addDynamic.description,
            backgroundColor: vm.addDynamic.backgroundColor,
            apply: 2,
            pageItemList: pageItemVOList,
            id: vm.addDynamic.id
          }
          if (isNull(vm.addDynamic.id)) {
            addDynamic(pageData).then((resultData) => {
              if (resultData.code == 200) {
                vm.$message.success('保存成功')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 1000)
              }
              vm.saveLoading = false
            }).catch(() => {
              vm.saveLoading = false
            })
          } else {
            editDynamic(pageData).then((resultData) => {
              if (resultData.code == 200) {
                vm.$message.success('保存成功')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 1000)
              }
              vm.saveLoading = false
            }).catch(() => {
              vm.saveLoading = false
            })
          }

        }).catch(() => {
          vm.saveLoading = false
        })
      })
    },
    /*
     * 处理列表信息
     * */
    dealPageItemList() {
      const vm = this
      let verification = false
      const pageItemVOList = []
      for (let i = 0; i < vm.list.length; i++) {
        const ele = vm.list[i]
        if (ele.type === 'img') {
          if (ele.imgList.findIndex((element) => element.url.indexOf('data:image') === 0 || element.url === null) > -1) {
            vm.$message.error('图片组件未设置图片')
            verification = true
            break
          }
          // if(ele.rowCount != -1 && ele.imgList.findIndex((element) =>  isNull(element.hrefType)) > -1){
          //   vm.$message.error('请选择跳转路径')
          //   verification = true
          //   break
          // }
          const imgItem = {
            id: ele.id || '',
            type: 1,
            fillStyle: ele.fullType,
            rowCount: ele.imgType,
            dynamicPageItemPictures: [],
          }
          ele.imgList.forEach((element) => {
            element.hotList && element.hotList.forEach(v => { v.href = v.hrefType == 2 ? JSON.stringify({ doctorId: v.doctorId, doctorName: v.doctorName }) : v.href })
            const imgItemList = {
              shortPicUrl: element.src,
              picUrl: element.url,
              hrefType: element.hrefType,
              href: element.hrefType == 2 ? JSON.stringify({ doctorId: element.doctorId, doctorName: element.doctorName }) : element.href,
              hotList: element.hotList && element.hotList.length > 0 ? element.hotList : null,
              originWidth: element.originWidth,
              originHeight: element.originHeight,
              height: ele.height,
              width: ele.width
            }
            imgItem.dynamicPageItemPictures.push(imgItemList)
          })
          pageItemVOList.push(imgItem)
        } else if (ele.type === 'coupon') {
          if (ele.couponTypeId) {
            pageItemVOList.push({
              id: ele.id || '',
              type: 2,
              rowCount: ele.rowCount,
              dynamicPageItemCoupon:{
                couponTypeId:ele.couponTypeId,
                backgroundColor:ele.backgroundColor
              }
            })
          } else {
            vm.$message.error('优惠券组件未选择优惠券或优惠券并未修改')
            verification = true
            break
          }
        } else if (ele.type === 'text') {
          if (ele.data && ele.data.length > 0) {
            pageItemVOList.push({
              id: ele.id || '',
              type: 3,
              dynamicPageItemText: {
                content: ele.data
              }
            })
          } else {
            vm.$message.error('文本组件未定义内容')
            verification = true
            break
          }
        }
      }
      return {
        verification,
        pageItemVOList
      }
    },

  }
}
</script>
<style lang="less" scoped>
.dynamic_add {
  height: 100%;
  overflow: auto;
  padding: 30px 10px;
  box-sizing: border-box;
  background: #fff;

  .add_title {
    font-size: 20px;
    color: #3388ff;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
    position: relative;
    .add_back{
      position: absolute;
      top: 0;
      left: 20px;
    }
  }

  .phone {
    height: 639px;
    width: 314px;
    position: relative;
    float: left;
  }
  .phone__bg {
    height: 639px;
    width: 314px;
    position: absolute;
  }

  .phone__content {
    width: 272px;
    height: 482px;
    position: absolute;
    left: 21px;
    top: 81px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .phone__content::-webkit-scrollbar {
    width: 0;
  }

  .components__icon {
    line-height: 60px;
    font-size: 50px;
  }

  .components:hover .components__del {
    z-index: 10;
  }

  .components {
    min-height: 100px;
    width: 268px;
    border: 1px solid #0074D9;
    margin: 1px;
    cursor: pointer;
    position: relative;
    background-color: #ffffff;
    text-align: center;
  }
 

  .components__del {
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: -10;
  }
  .set {
    float: left;
    padding: 10px;
    margin-left: 10px;
    min-width: 500px;
    width: 700px;
  }

  .box-card {
    width: 100%;
  }
  .box-card__prompt {
    margin-left: 30px;
    font-size: 12px;
  }
  .background__img2 {
    width: 71px;
    height: 100px
  }
   .components__coupon {
    text-align: left;
    position: relative;
    .coupon_warp{
      padding: 8px;
      box-sizing: border-box;
      .coupon_warp_content{
        display: flex;
        align-items: center;
        .coupon_warp_content_left{
          padding: 16px;
          border-radius: 8px;
          background: #FFF2D5;
          box-sizing: border-box;
          .coupon_price_warp{
            color: #FF6522;
            font-weight: 600;
            font-size: 13px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
          }
        }
        .coupon_warp_content_right{
          flex: 1;
          margin-left: 8px;
          text-align: center;
          font-size: 13px;
        }
      }
      .coupon_warp_bottom{
        padding-top: 8px;
        margin-top: 8px;
        border-top: 1px dashed #E5E5E5;
        font-size: 13px;
      }
    }

  }
}
</style>